import { render, staticRenderFns } from "./TargetsView.vue?vue&type=template&id=5bdd822b&"
import script from "./TargetsView.vue?vue&type=script&lang=js&"
export * from "./TargetsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports